export default {
    title: "Une erreur s'est produite 😢",
    description: 'Ne vous inquiétez pas! Nous avons reçu la notification et nous travaillons pour résoudre cette erreur!',
    loginCancelled: 'Connexion annulée',
    facebook: {
        sdkNotLoaded: 'SDK Facebook non chargé',
        sdkInitFailed: "Échec de l'initialisation du SDK Facebook",
        loginFailed: 'Échec de la connexion',
        loginCancelled: 'Connexion Facebook annulée',
        permissionsRequired: {
            title: 'Permissions requises',
            description: 'Pour lier votre compte, vous devez activer toutes les permissions demandées par Facebook.',
            steps: {
                step1: "Sur l'écran Facebook, cliquez sur « Modifier les paramètres »",
                step2: 'Activez chaque permission affichée',
                step3: 'Enregistrez et réessayez de lier votre compte',
            },
        },
    },
    business: {
        noBusiness: "Il semble qu'aucune entreprise ne soit liée à ce compte",
    },
};
